export { weakKey } from './utils/weak-key';